import React, { useState } from 'react';

import { AppWrapper, ScrollSnapAlignWrapper } from '../ui/wrappers';

import NavBar from './NavBar';
import Particle from './Particle';
import Home from './Home';
import AboutMe from './AboutMe';
import Projects from './Projects';
import ContactMe from './ContactMe';

function App() {
    const [particleInit, setParticleInit] = useState(false);

    return (
        <>
            <Particle particleInit={particleInit} setParticleInit={setParticleInit} />
            {particleInit && (
                <AppWrapper>
                    <ScrollSnapAlignWrapper>
                        <Home />
                    </ScrollSnapAlignWrapper>
                    <ScrollSnapAlignWrapper>
                        <NavBar />
                        <AboutMe />
                        <Projects />
                        <ContactMe />
                    </ScrollSnapAlignWrapper>
                </AppWrapper>
            )}
        </>
    );
}

export default App;
